import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

import { BaseProductInterface } from '../../../../core';
import { BaseUI } from '../../base.ui';
import { Id } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
})
export class ProductCardComponent extends BaseUI implements AfterViewInit, OnDestroy {
    @Input()
    product: BaseProductInterface;

    @Input()
    disabled = false;

    @Input()
    isAppropriateness = true;

    @Input()
    requiredExonerate = false;

    @Output()
    detail: EventEmitter<Id> = new EventEmitter();

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    onClick() {
        if (!this.disabled) {
            this.product.selected = !this.product.selected;
        }
    }

    onDetail(event: Event) {
        event.stopImmediatePropagation();
        event.stopPropagation();

        this.detail.emit(this.product.encryptedCode as Id);
    }
}
